Vue.component("checkboxes", {
  props: {
    field: {
      type: String
    },
    title: {
      type: String
    },
    async: {
      type: Boolean,
      required: false,
      default: false
    },
    startselected: {
      required: false,
      default: false
    },
    items: {
      type: Array,
      required: false,
      default: () => []
    },
    filters: {
      type: Object,
      required: false,
      default: () => {}
    },
    resultstring: {
      type: String
    },
    labelfield: {
      type: String
    },
    selectedkey: {
      type: String
    },
    selectedgroup: {
      type: String
    },
    selectedmax: {
      type: Number,
      default: -1
    }
  },
  data() {
    return {
      selected: [],
      data: [],
      isLoading: false,
      mounted: false,
      id: "checkboxes_" + this.makeid(),
      yeararray: SLIDEStaffingYearsArray,
      years: SLIDEStaffingYears
    };
  },
  computed: {
    activeData() {
      let k = this.data;
      let trigger;
      if (this.filters && this.mounted) {
        let f = this.filters;
        for (const key in f) {
          trigger = document.getElementsByName(f[key].trigger);
          if (trigger.length > 0) {
            for (let i = 0; i < trigger.length; i++) {
              if (trigger[i].value == f[key].value && trigger[i].checked == true) {
                k = k.filter(function (item) {
                  for (let j = 0; j < f[key].filtervalues.length; j++) {
                    if (item[f[key].filterfield] == f[key].filtervalues[j]) {
                      return true;
                    }
                  }
                  return false;
                });
              }
            }
          }
        }
      }
      return k;
    },
    groupedData() {
      let k = [];
      // set default as an untitled single group
      k[0] = { title: false, subtitle: false, data: this.activeData };
      let a;
      if (this.field == "data_field_id") {
        let groups = [
          "District Identification",
          "Library Staff (Full-Time Equivalents)",
          "Student Demographics",
          "Other District/School Staff"
        ];
        let top = groups.length;
        let j = 0;
        for (let i = 0; i < top; i++) {
          switch (groups[j]) {
            case "Library Staff (Full-Time Equivalents)":
            case "Student Demographics":
              let topgroup = ["Librarians", "LSupport"];
              let toplabel = false;
              let secondlabel = "Library Staff Ratios";
              if (groups[j] == "Student Demographics") {
                topgroup = [
                  "AmerIndAKnative",
                  "AsianAPI",
                  "Black",
                  "HawaiianPI",
                  "White",
                  "TwoplusRaces",
                  "Hispanic",
                  "MajNonWhit",
                  "MajHisp"
                ];
                toplabel = "Race/Ethnicity";
                secondlabel = "Other Characteristics";
              }
              a = this.activeData.filter(function (item) {
                if (item["data_group"] == groups[j]) {
                  if (topgroup.includes(item["data_abbreviation"])) {
                    return true;
                  }
                }
                return false;
              });
              k[i] = { title: groups[j], subtitle: toplabel, data: a };

              top++;
              i++;

              a = this.activeData.filter(function (item) {
                if (item["data_group"] == groups[j]) {
                  if (!topgroup.includes(item["data_abbreviation"])) {
                    return true;
                  }
                }
                return false;
              });
              k[i] = { title: false, subtitle: secondlabel, data: a };
              break;

            default:
              a = this.activeData.filter(function (item) {
                if (item["data_group"] == groups[j]) {
                  return true;
                }
                return false;
              });

              k[i] = { title: groups[j], subtitle: false, data: a };
              break;
          }
          j++;
        }
      }

      return k;
    }
  },
  created() {
    if (this.async) {
      this.isLoading = true;
    }
  },

  async mounted() {
    this.mounted = true;
    if (this.field == "data_field_id") {
      this.updateStaffingYears();
    }
    if (this.async) {
      this.$emit("isloading", this.id);

      // CHECK LOCAL STORAGE FOR APPROPRIATE FIELDS
      let data = {};
      let obj = new FormData();
      obj.append("action", "slide_get_data");
      obj.append("field", this.field);
      if (this.field == "data_field_id") {
        newdata = slideGetStorage(this.field);
        if (newdata && newdata[20] && newdata[20].data_format == "Number2") {
          data.data = newdata;
        } else {
          data = await axios.post(axios_ajax.ajaxurl, obj);
          slideSetStorage(this.field, data.data);
        }
      } else {
        data = await axios.post(axios_ajax.ajaxurl, obj);
      }
      this.data = data.data;
      /*
            let obj = new FormData;
            obj.append('action', 'slide_get_data');
            obj.append('field', this.field)
            
            let data = await axios.post(axios_ajax.ajaxurl, obj);
            this.data = data.data;
        */
      this.isLoading = false;

      this.$emit("isloaded", this.id);
      if (this.field == "data_field_id") {
        let ignoreDataPoints = ["3", "27", "7", "34"];

        this.data = this.data.filter(function (item) {
          return !ignoreDataPoints.includes(item.data_field_id);
        });

        this.$emit("fielddataloaded", this.data);
      }
    } else {
      this.isLoading = false;
      this.data = this.items;
    }

    this.$nextTick(function () {
      if (this.startselected) {
        let checks = document.getElementsByClassName(this.selectedkey + "_check");
        for (var i = 0; i < checks.length; i++) {
          checks[i].click();
        }
      }
    });
  },
  methods: {
    makeid() {
      var text = "";
      var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      for (var i = 0; i < 10; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      }

      return text;
    },
    updateCheckbox(data, event) {
      if (!this.checkMax(event)) {
        alert(
          "For the interface to work, no more than " + this.selectedmax + " options can be selected"
        );
        event.target.checked = false;
        exit;
      }
      if (event.target.checked) {
        this.selected.push(data);
      } else {
        this.selected = this.selected.filter(
          (item) => item[this.selectedkey] !== data[this.selectedkey]
        );
      }
      let filtervalues = {
        field: this.field,
        selected: this.selected,
        key: this.selectedkey
      };
      this.$emit("updatesearch", this.selectedgroup, filtervalues);
    },
    updateStaffingYears() {
      this.selected.staffing_years = this.years;
      let filtervalues = {
        field: "staffing_years",
        selected: this.years,
        key: "staffing_years"
      };
      this.$emit("updatesearch", "filters", filtervalues);
    },
    checkMax(event) {
      // if no max, ignore
      if (this.selectedmax == -1 || !event.target.checked) {
        return true;
      }
      // ADD 1 BECAUSE THE ONE SELECTED HASN'T BEEN BEEN ADDED YET TO THE ARRAY
      let num = this.selected.length + 1;
      if (num > this.selectedmax) {
        return false;
      }
      return true;
    },
    getCheckboxID(d, i) {
      if (d.data_field_id) {
        return this.selectedkey + "_check_" + d.data_field_id;
      }
      return this.selectedkey + "_check_" + i;
    },
    getCheckboxLabel(d) {
      if (SLIDEStaffingFields.includes(+d.data_field_id)) {
        return d[this.labelfield] + "*";
      }
      return d[this.labelfield];
    },
    getPercentObject(d) {
      let newAbbr = d.data_abbreviation + "Pct";
      newobj = false;
      for (let obj of this.data) {
        if (obj.data_abbreviation == newAbbr) {
          newobj = obj;
        }
      }
      return newobj;
    }
  }
});
